import axios from 'axios';
import CryptoJS from 'crypto-js';
import BaseUrl from '_conf/url';

/**
 * 得到验证码
 */
export const captchaGet = () => axios.$callAPI(() => axios.get(BaseUrl.Url + '/captcha/get'));

/**
 * 验证验证码
 */
export const captchaVerify = (data, captcha_key) =>
    axios.$callAPI(() => axios.get(BaseUrl.Url + '/captcha/check'), data, { headers: { captcha_key: captcha_key } });

/**
 * 注册
 */
export const register = (data, captcha_key) =>
    axios.$callAPI(() => axios.post('auth/register', data, { headers: { captcha_key: captcha_key } }));

/**
 * 登陆
 */
export const login = async (data, captcha_key) => {
    const keys = await axios.$callAPI(() => axios.get('auth?client=get'));
    //console.log(keys);
    const tokenKey = CryptoJS.enc.Utf8.parse(keys.token_key);
    const src = CryptoJS.enc.Utf8.parse(data.password);
    data.password = CryptoJS.AES.encrypt(src, tokenKey, {
        iv: tokenKey,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    }).toString();
    return await axios.$callAPI(() =>
        axios.post('auth/login', data, {
            headers: {
                user_key: keys.user_key,
                captcha_key: captcha_key,
            },
        })
    );
};

/**
 * unlock
 */
export const validatePassword = data => axios.$callAPI(() => axios.post('users/unlock', data));

/**
 * 退出
 */
export const logout = () => axios.$callAPI(() => axios.post('users/logout'));
